import {
  DEFAULT_OG_IMAGE_HEIGHT,
  DEFAULT_OG_IMAGE_WIDTH,
  getSectionOgImageUrl,
} from "@config/ogImageConstants";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function HomeMetaData(section: string): PageMetaDataValues {
  const metaTags: MetaTagsProps = {
    title: "Beritaharian - Berita Utama, Singapura, Ekoniaga, Dunia & Sukan",
    description:
      "Berita Harian Singapura - Dapatkan berita utama, laporan eksklusif, analisis mendalam dan kandungan berbilang media mengenai Singapura, Asia dan dunia.",
    slug: "",
    ogImage: {
      url: getSectionOgImageUrl("default"),
      width: DEFAULT_OG_IMAGE_WIDTH,
      height: DEFAULT_OG_IMAGE_HEIGHT,
    },
  };

  const gaData: GADataProps = {
    level2: section,
    title: "BH_Homepage",
    section: section,
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
